import React from "react";

import Layout from "./Layout";

const Content = props => <Layout {...props} type="Content" />;

export default Content;



// WEBPACK FOOTER //
// ./src/editor/layout/components/ContentContainer.js